import { ar as shared } from '@/modules/shared/locale/ar';
import { ar as payment } from '@/modules/payment/locale/ar';
import { ar as requests } from '@/modules/requests/locale/ar';

const ar = {
  shared,
  payment,
  requests,
};

export default ar;
